/* eslint-disable  */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
/* eslint-disable  */
// @ts-nocheck
import * as React from 'react';
import {
  Box,
  Grid,
  Typography,
  Button,
  IconButton,
  InputLabel,
  TextField,
  OutlinedInput,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  FormHelperText,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MainLogo from '../../../components/MainLogo/MainLogo.components';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import SignUp from '../SignUp/SignUp.screen';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useLogin } from '../hooks/useLogin';
import ChangePassword from '../ChangePassword/ChangePassword.screen';

const SignIn = ({ page, handlePages, closeDrawer }) => {
  // Start Input Password Code
  interface State {
    amount: string;
    password: string;
    weight: string;
    weightRange: string;
    showPassword: boolean;
  }
  const [values, setValues] = React.useState<State>({
    amount: '',
    password: '',
    weight: '',
    weightRange: '',
    showPassword: false,
  });
  const handleChange = (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues({ ...values, [prop]: event.target.value });
  };
  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const validationSchema = yup.object({
    email: yup
      .string('Enter your email')
      .email('Enter a valid email')
      .required('Email is required'),
    password: yup
      .string('Enter your password')
      .min(8, 'Password should be of minimum 8 characters length')
      .required('Password is required'),
  });

  const { signIn } = useLogin();

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      signIn(values, callBack);
      //   alert(JSON.stringify(values, null, 2));
    },
  });

  const callBack = () => {
    formik.resetForm();
    closeDrawer('signIn');
  };

  const renderPage = () => {
    if (page === 0) {
      return (
        <form onSubmit={formik.handleSubmit}>
          <Grid>
            <Box sx={{ mt: 2, mb: 3 }}>
              <Typography variant="h4" sx={{ mb: 1 }}>
                Sign in
              </Typography>
              <Typography variant="body2">
                Signing in will allow you to view and access your saved scenes
              </Typography>
            </Box>
            <Box className="CommonFormControl">
              <InputLabel>Email *</InputLabel>
              <TextField
                label=""
                variant="outlined"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Box>
            <Box className="CommonFormControl">
              <InputLabel className="PasswordLabelBox">
                Password *
                {/* <a
                  className="ForgotPassword"
                  onClick={() => {
                    formik.resetForm();
                    handlePages(2);
                  }}
                >
                  Forgot your password?
                </a> */}
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-password"
                type={values.showPassword ? 'text' : 'password'}
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                error={formik.touched.password && Boolean(formik.errors.password)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {values.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Password"
              ></OutlinedInput>
              <FormHelperText
                error={formik.touched.password && formik.errors.password}
                id="accountId-error"
              >
                {formik.errors.password}
              </FormHelperText>
            </Box>
          </Grid>
          <Grid className="DialogActionsBlock">
            <Box>
              <Button
                className="CommonModalButton FullWidthButton"
                color="primary"
                variant="contained"
                type="submit"
              >
                Sign In
              </Button>
            </Box>
            <Box
              className="SignUpBox"
              sx={{ textAlign: 'center', mt: 3 }}
              onClick={() => {
                formik.resetForm();
                handlePages(1);
              }}
            >
              <Typography variant="body2">
                Don’t have an account?{' '}
                <a
                  className="UnderLineLink"
                  // onClick={props.onClickSignup}
                >
                  Sign up
                </a>
              </Typography>
            </Box>
          </Grid>
        </form>
      );
    } else if (page === 1) {
      return <SignUp handlePages={handlePages} />;
    } else if (page === 2) {
      return <ChangePassword />;
    }
  };

  return <>{renderPage()}</>;
};

export default SignIn;
